import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { UpdateUilmTranslationJobMutation, UpdateUilmTranslationJobMutationVariables } from '@/graphql/generated/graphql';
import { UpdateUilmTranslationJobDocument } from '@/graphql/generated/graphql';
export type UilmTranslationJobUpdateInput = {
  ItemId: string
  OrganizationIds?: string[]
  MessageCoRelationId?: string
  TemplateId?: string
  TemplateSlug?: string
  ModuleId?: string
  DefaultLanguage?: string
  Status?: string
  StartedAt?: string
  CompletedAt?: string
  ErrorMessage?: string
}

export type UpdateUilmTranslationJobResponse = {
  data: {
    updateUilmTranslationJob: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useUpdateUilmTranslationJob = () => {
  const mutation = useMutation({
    mutationKey: ['update-uilm-translation-job'],
    mutationFn: (variables: UilmTranslationJobUpdateInput) => {
      return graphqlClient.request<UpdateUilmTranslationJobMutation>(UpdateUilmTranslationJobDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateUilmTranslationJob: mutation.mutate,
    updateUilmTranslationJobAsync: mutation.mutateAsync,
  }
}

export const UPDATE_UILM_TRANSLATION_JOB_MUTATION = UpdateUilmTranslationJobDocument;
